import { message, Slider } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { IClient } from "../../pages/Clients";
import { api } from "../../services/api";
import { Modal } from "../Modal";
import { Content } from "./styles";
import { ThemeContext } from "styled-components";
import { Load } from "../Load";
import { useAuth } from "../../hooks/auth";

interface Props {
  client: IClient;
  title: string;
  confirm: (client: IClient) => void;
  cancel: () => void;
}
export function AllocateMessageLimitModal({
  client,
  title,
  confirm,
  cancel,
  ...rest
}: Props) {
  const { user } = useAuth();
  const theme = useContext(ThemeContext);
  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(client.messageLimit);
  function allocate() {
    setLoadingBtn(true);
    api
      .post("clients/limit", {
        clientId: client.id,
        limit
      })
      .then(() => {
        message.success("Limite alocado com sucesso!");
        confirm({
          ...client,
          messageLimit: limit
        });
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => setLoadingBtn(false));
  }
  function handleChangeMessageLimit(ev: number) {
   setLimit(ev)
  }
  function fetchData() {
    api
      .get<{ total: number; used: string }>(`users/limit/${user.id}`)
      .then((response) => {
        const { total,used } = response.data;
        console.log(response.data);
        setTotal((total - Number(used) )+ client.messageLimit);
      })
      .catch((e) => {})
      .finally(() => setLoading(false));
  }
  useEffect(fetchData, []);
  return (
    <Modal
      cancel={cancel}
      confirm={allocate}
      title={title}
      btnTitle="Confirmar"
      loading={loadingBtn}
    >
      <Content>
        {loading ? (
          <Load />
        ) : (
          <>
            <div className="details">
              <p>
                Limite disponível: <span>{total}</span>
              </p>
              <p>
                Limite atual do cliente: <span>{client.messageLimit}</span>
              </p>
            </div>
            <Slider
            onChange={(ev) => handleChangeMessageLimit(ev)}
              defaultValue={client.messageLimit}
              max={total}
              trackStyle={{
                background: theme.colors.primary,
                height: "19px",
                borderRadius: "8px",
              }}
              handleStyle={{
                height: "26px",
                width: "26px",
              }}
            />
            <div className="total">
              Novo limite: <span>{limit}</span>
            </div>
          </>
        )}
      </Content>
    </Modal>
  );
}
